/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGraduationCap, 
  faBriefcase, 
  faUserTie,
  faRocket
} from '@fortawesome/free-solid-svg-icons';
import '../styles/ThemedLoadingSpinner.css';

// Theme configuration outside component to avoid recreation
const THEME_CONFIGS = {
  intern: {
    primaryColor: '#f97316',
    secondaryColor: '#0d9488',
    accentColor: '#ea580c',
    lightColor: '#fef7ed',
    icon: faGraduationCap,
    name: 'Intern'
  },
  jobseeker: {
    primaryColor: '#f97316',
    secondaryColor: '#0d9488',
    accentColor: '#ea580c',
    lightColor: '#fef7ed',
    icon: faBriefcase,
    name: 'Job Seeker'
  },
  recruiter: {
    primaryColor: '#f97316',
    secondaryColor: '#ea580c',
    accentColor: '#c2410c',
    lightColor: '#fff7ed',
    icon: faUserTie,
    name: 'Recruiter'
  }
};

function ThemedLoadingSpinner({ 
  theme = 'intern',
  size = 'large',
  text = 'Loading your dashboard...',
  subText = '',
  showIcon = true,
  fullScreen = true
}) {
  const themeConfig = THEME_CONFIGS[theme] || THEME_CONFIGS.intern;
  const containerClass = `themed-loading-container ${theme} ${size} ${fullScreen ? 'fullscreen' : ''}`;
  
  return (
    <div className={containerClass}>
      <div className="themed-loading-content">
        <div className="themed-loading-animation">
          <div className="themed-loading-ring outer">
            <div className="themed-loading-ring-inner"></div>
          </div>
          <div className="themed-loading-ring middle">
            <div className="themed-loading-ring-inner"></div>
          </div>
          <div className="themed-loading-ring inner">
            <div className="themed-loading-ring-inner"></div>
          </div>
          {showIcon && (
            <div className="themed-loading-icon">
              <FontAwesomeIcon icon={themeConfig.icon} />
            </div>
          )}
        </div>
        <div className="themed-loading-text">
          <h3 className="themed-loading-title">{text}</h3>
          {subText && <p className="themed-loading-subtitle">{subText}</p>}
        </div>
        <div className="themed-loading-dots">
          <span className="themed-dot"></span>
          <span className="themed-dot"></span>
          <span className="themed-dot"></span>
        </div>
      </div>
      <div className="themed-loading-background">
        <div className="themed-pulse-ring"></div>
        <div className="themed-pulse-ring delay-1"></div>
        <div className="themed-pulse-ring delay-2"></div>
      </div>
    </div>
  );
}

export default ThemedLoadingSpinner;
